import { pBtn } from "components/main.styled";
import styled from "styled-components";

export const ViewContainer = styled.div`
    margin-top: 24px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    height: 100%;
    width: 100%;
    
`

export const BottomWrap = styled.div`  
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
`
export const SubmitButton = styled(pBtn)`
    width: ${props => props.width ? props.width : '140px' };
    background-color: ${props => props.disabled ? '#21ad46' : '#eef9f1'};
    color: ${props => props.disabled ? 'white' : '#168236'};
    border: 1px solid ${props => props.disabled ? '#21ad46' : '#cdebd5'};
    border-radius: 7px;
    font-weight: 700;
    pointer-events: ${props => props.disabled ? 'none' : 'auto'}; 
    &:hover{
        background-color: #21ad46;
        color: white;
        transform: translateY(-1px);
    }
`

export const FormWrap = styled.div`
    display: flex;  
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    height: 100%;
    width: 100%;

    @media (max-width: 768px){
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
    }

`

export const PaymentProcessContainer = styled.div`

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    width: 100%;
    height: 100%;
 
`

export const LeftSide = styled.div`
    font-size: 15px;
    color: var(--lightThemeFontColor);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 300px;
    width: 40%; 
    padding: 20px;
    background-color: white;
    border-radius: 8px;
    border: 1px solid #edf0f2;
    box-shadow: 0 4px 16px rgba(61, 70, 78, 0.10);

    h3{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        font-size: 2rem;
        font-weight: 600;
        margin-top: 20px;
        span{
            margin-left: 0px;
        }
    }

    @media (max-width: 768px){
        width: 70%; 
        height: 450px;
    }

`
export const GiveForm = styled.div`
    padding: 20px;
    padding-top: 0px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    height: 100%;
    width: 60%;

    @media (max-width: 768px){
        width: 100%; 
        height: 400px;
        margin-top: 30px;
        justify-content: flex-start;
        align-items: center;
    }
`


export const GivingButton = styled(pBtn)`
    pointer-events: ${props => props.active ? 'none' : 'auto'};
    background-color: ${props => props.active ? '#eef9f1' : '#f2f6f8'};
    color: ${props => props.active ? '#168236' : '#626b70'};
    border: 1px solid ${props => props.active ? '#cdebd5' : '#e1e7eb'};
    border-radius: 7px;
    font-weight: 700;
    transition: background-color 0.3s;

    &:hover{
        background-color: ${props => props.active ? '#eef9f1' : '#eef1f3'};
    }
 

`

export const TransactionsTableContainer = styled.table`
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
    cursor: context-menu; 
    color: #585858;
    background: white;
    border: 1px solid #edf0f2;
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(61, 70, 78, 0.10);
    overflow: hidden;

    th { 
        border: 1px solid #edf0f2;
        text-align: center;
        padding: 10px 8px;
        background-color: #f2f6f8;
        color: #626b70;
        font-weight: 700;
    }

    tr:nth-child(even) {
        background-color: #fbfcfd;
    }
 
    td {
        color: #585858;
        position: relative;
        text-align: center;
        font-size: 12px;
        border: 1px solid #edf0f2;
        padding: 8px 4px;
    }

    @media (max-width: 768px){
        th{
            font-size: 10px;
            padding: 3px;
        }
        td{
            font-size: 9px;
            padding: 0px;
        }
    }

`

export const StyledInput = styled.div`
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start; 
    width: 100%;
    color: var(--lightThemeFontColor);

    label{
        font-size: 12px;  
    }

    @media (max-width: 768px){
        width: 100%;
    }
`
export const InputIconWrap = styled.div`
    width: 100%; 
    transition: all 0.6s ease-in-out;
    border: ${props => props.isError ? '1px solid #b73525' : '1px solid #dfe7ec'};
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(61, 70, 78, 0.08);
    background-color: #fbfcfd;

    input{
        width: 100%;
        padding: 15px;
        border: 1px solid transparent;
        border-radius: 8px;
        outline: none;
        background-color: #fbfcfd;
    }

    @media (max-width: 768px){
        /* width: 90%; */
    }

    /* focus within */

    input:focus{
        
        transition: all 0.3s ease-in-out;

        border: 1px solid #21ad46;
        box-shadow: 0 0 0 3px rgba(33, 173, 70, 0.12);
    }

`

export const DH1 = styled.h1`
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 20px;
    color: var(--lightThemeFontColor);
    svg {
        margin-right: 10px;
        font-size: 25px;
    }

`

export const DonateContainer = styled.div` 
    position: relative;
    width: 100%;
    padding: 10px;
    display: flex;
    flex-direction: column;
    background-color: white ;
    border-radius: 8px;
    border: 1px solid #edf0f2;
    box-shadow: 0 4px 16px rgba(61, 70, 78, 0.10);
    min-height: 400px;
    height: fit-content;
    max-height: ${props => props.maxHeight };
    overflow-y: scroll;
    /* hide scroll bar */
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
        display: none;
    }

    @media (max-width: 768px){
        margin-bottom: 110px;
    }
`
